import { Button, Col, Divider, InfoPopup, Loader, Row } from "@/components";
import clsx from "clsx";
import { ComponentType } from "react";
import { EditPencil } from "../../../icons";
import "./CardScreening.scss";

type CardScreeningProps = {
  title: string;
  infobox?: string;
  badge?: {
    text?: string;
    color?: string;
  };
  date?: {
    label: string;
    value: string;
  };
  address?: {
    label: string;
    value: string;
  };
  description?: string;
  footer?: {
    ctaLeft?: {
      label?: string;
      clickCta?: () => void;
    },
    ctaRight?: {
      label?: string;
      href?: string;
    }
  };
  isLoading?: boolean;
  asLink?: "a" | ComponentType<any>;
};

export const CardScreening = ({
  title,
  infobox,
  badge,
  date = undefined,
  address = undefined,
  description = undefined,
  footer,
  isLoading = false,
  asLink = "a",
}: CardScreeningProps) => {
  const LinkComponent = asLink;

  return (
    <div
      className={clsx(
        "ui-card-screening shadow fw-semibold text-slate-28 fs-7 py-x16 px-x24",
      )}
    >
        <Col
          justifyContent={"space-between"}
          gap={"x8"}
        >
          <Row alignItems="center" gap="x8">
            <h3
              className={clsx(
                "ui-card-screening-title fs-4 text-slate-20",
                "cursor-pointer hover-underline",
              )}
            >
              <LinkComponent className="link-unstyled" href={footer?.ctaRight?.href ?? "#"}>
                {title}
              </LinkComponent>
            </h3>
            {infobox && (<InfoPopup title={title} description={infobox} /> )}
          </Row>
          <Row justifyContent={"flex-start"} alignItems={"center"}>
            {badge?.text && (
              <div
                className={clsx(
                  "rounded py-x4 px-x16",
                )}
                style={{ backgroundColor: badge.color || "#000", color: "#fff", width: "max-content" }}
              >
                {badge.text}
              </div>
            )}
          </Row>

          {date && (
            <Row className={"fw-regular gap-x4 body-text-screening-card"}>
              <span className={"fw-semibold"}>{date.label}:</span>
              <span>{date.value}</span>
            </Row>
          )}
          {address && (
          <Row className={"fw-regular gap-x4 body-text-screening-card"}>
              <span className={"fw-semibold"}>{address.label}:</span>
              <span>{address.value}</span>
            </Row>
          )}
          {description && (
          <p className={"fw-regular body-text-screening-card"}>
              {description}
            </p>
          )}
        </Col>


        {/* FOOTER */}
        {footer && (
          <Col className="ui-card-screening-footer">
            <Row className="ui-card-screening-footer-actions" justifyContent={footer?.ctaLeft ? "space-between" : "flex-end"} alignItems={"center"}>
              {footer?.ctaLeft && (
                <Row
                  alignItems={"center"}
                  className={clsx(
                    !isLoading && "cursor-pointer",
                    "text-decoration-none text-primary",
                    "ui-card-screening-download-row gap-x8",
                  )}
                  onClick={isLoading ? undefined : footer?.ctaLeft?.clickCta}
                >
                  <EditPencil />
                  <p>{footer?.ctaLeft?.label}</p>
                  <Loader loading={isLoading} className={"ml-x8"} />
                </Row>
              )}
              {footer?.ctaRight && footer?.ctaRight?.href && (
                <>
                  <Divider bg={"border-divider"} className="ui-document-divider" />
                  <Button
                    fwClassName="fw-semibold"
                    className="ui-card-screening-cta px-x12"
                    variant="secondary"
                    size="5"
                    asLink={LinkComponent}
                    href={footer?.ctaRight?.href ?? undefined}
                  >
                    {footer?.ctaRight?.label}
                  </Button>
                </>
              )}
            </Row>
          </Col>
        )}
    </div>
  );
};
